const listText = (items = [], limit = 4) => (
  Array.isArray(items)
    ? items.filter(Boolean).slice(0, limit).map((item) => `- ${String(item).trim()}`).join('\n')
    : ''
);

const getTrainingTitle = (training = {}) => training.title || training.name || 'Treino da Coach';

const renderLockedTraining = (training = {}) => [
  `${getTrainingTitle(training)} esta bloqueado no seu plano atual.`,
  training.preview || training.objective || 'Posso mostrar a previa, mas o conteudo completo depende do Pro.',
  'Se quiser liberar esse treino, abra os planos Pro.'
].filter(Boolean).join('\n\n');

const renderTrainingDetail = (training = {}) => {
  if (training.locked || training.previewOnly || training.accessAllowed === false) {
    return renderLockedTraining(training);
  }

  const steps = Array.isArray(training.steps)
    ? training.steps.slice(0, 5).map((step, index) => {
      if (typeof step === 'string') return `${index + 1}. ${step}`;
      return `${index + 1}. ${step.title || step.name || 'Passo'}${step.description ? ` - ${step.description}` : ''}`;
    }).join('\n')
    : '';

  return [
    getTrainingTitle(training),
    training.objective || training.summary || training.preview || null,
    listText(training.forWho, 3) ? `Para quem e:\n${listText(training.forWho, 3)}` : null,
    steps ? `Passo a passo:\n${steps}` : null,
    listText(training.commonMistakes, 3) ? `Evite:\n${listText(training.commonMistakes, 3)}` : null,
    training.coachTip ? `Dica da Mi: ${training.coachTip}` : null,
    training.estimatedDurationMinutes ? `Duracao: ${training.estimatedDurationMinutes} min` : null
  ].filter(Boolean).join('\n\n');
};

const renderTrainingSummary = (training = {}) => [
  getTrainingTitle(training),
  training.objective || training.preview || training.summary || null,
  training.locked ? 'Esse treino aparece como Pro para o seu acesso atual.' : 'Esse treino esta disponivel para continuar agora.',
  training.estimatedDurationMinutes ? `Duracao: ${training.estimatedDurationMinutes} min` : null
].filter(Boolean).join('\n\n');

const renderProgress = (result = {}) => {
  const progress = result.progress || {};
  const saved = result.saved || {};
  const completed = Object.values(progress).filter((entry) => entry?.completed || entry?.status === 'completed').length;
  const savedCount = Object.keys(saved).length;
  const profile = result.profile || {};

  return [
    'Resumo da Coach',
    profile.currentGameId || profile.gameId ? `Jogo do perfil: ${profile.currentGameId || profile.gameId}` : null,
    `Treinos concluidos: ${completed}`,
    `Treinos salvos: ${savedCount}`,
    result.recommendations?.summary || null
  ].filter(Boolean).join('\n\n');
};

const renderConfirmation = (result = {}) => [
  result.title || 'Coach atualizada',
  result.message || null,
  result.trainingId ? `Treino: ${result.trainingId}` : null
].filter(Boolean).join('\n\n');

export const renderCoachTrainingResult = (data = {}) => {
  const kind = data.kind || 'training';

  if (kind === 'progress_summary') return renderProgress(data);
  if (kind === 'action_confirmation') return renderConfirmation(data);
  if (kind === 'training_detail') return renderTrainingDetail(data.training || {});
  if (kind === 'training_recommendation') {
    const trainingText = (
      data.training
      && !data.training.locked
      && data.training.accessAllowed !== false
      && Array.isArray(data.training.steps)
      && data.training.steps.length > 0
    )
      ? renderTrainingDetail(data.training)
      : renderTrainingSummary(data.training || {});

    return [
      data.reason || 'Escolhi um treino real da biblioteca da Coach para o seu objetivo.',
      data.training?.id ? trainingText : null
    ].filter(Boolean).join('\n\n');
  }

  return renderTrainingSummary(data.training || data);
};

export const renderCoachTrainingHumanError = ({ status, message } = {}) => {
  if (status === 403) {
    return message || 'Esse recurso da Coach depende do seu acesso atual. Posso te mostrar um caminho liberado ou os planos Pro.';
  }
  if (status === 404) {
    return 'Nao encontrei esse treino na biblioteca da Coach.';
  }
  return message || 'Nao consegui abrir a Coach agora. Tenta novamente em instantes.';
};

export default renderCoachTrainingResult;
